import { UniverseApp } from './universe/UniverseApp';
import './styles.css';

const container = document.getElementById('universe-root');
if (!container) throw new Error('缺少宇宙容器');
let app: UniverseApp;
try {
  app = new UniverseApp(container);
  if (import.meta.env.DEV) {
    Object.assign(window, { universe: {
      get: () => app,
      destroy: () => app.destroy(),
      remount: () => { app.destroy(); app = new UniverseApp(container); return app; },
    } });
    if (new URLSearchParams(window.location.search).has('debug')) {
      void import('./devtools').then(({ mountDiagnostics }) => {
        const dispose = mountDiagnostics(container, () => app, () => { app.destroy(); app = new UniverseApp(container); });
        if (import.meta.hot) import.meta.hot.dispose(dispose);
      });
    }
  }
  if (import.meta.hot) import.meta.hot.dispose(() => app.destroy());
} catch (error) {
  console.error('Universe initialization failed', error);
  container.innerHTML = '<div class="error-screen"><span>DICEAI / SPACE</span><h1>暂时无法望见星空</h1><p>请开启浏览器硬件加速，使用支持 WebGL 2 的新版浏览器。</p><button type="button">重新出发</button></div>';
  container.querySelector('button')?.addEventListener('click', () => window.location.reload());
}
